import { render } from "./user-quotes.vue?vue&type=template&id=5fe27f96&scoped=true"
import script from "./user-quotes.vue?vue&type=script&lang=js"
export * from "./user-quotes.vue?vue&type=script&lang=js"

import "./user-quotes.vue?vue&type=style&index=0&id=5fe27f96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe27f96"]])

export default __exports__